export default __webpack_public_path__ + "media/components/ParallaxCrayon/crayon_1-af8d0e42ae7915f58fe9216553f698a7.png";